import { render, staticRenderFns } from "./UiModalDelete.vue?vue&type=template&id=5d6bff9e&"
import script from "./UiModalDelete.vue?vue&type=script&lang=js&"
export * from "./UiModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports